import styled from 'styled-components'
import {
  Empty, IdInterpreationBody, IdInterpretationHead,
  IdRecommendationsBody,
  IdRecommendationsHead,
  NothingFound,
} from './tableComponents'
import Table from '../../../myTable/MyTable'
import { useAppSelector } from '../../../../hooks/redux'
import { filter } from 'underscore'
import { useState } from 'react'
import { MAX_PER_PAGE } from '../../../../constants/other'
import {EmptyTable} from "../../../../pages/subjects/Subject";

const TableStyle = styled.div<{ hasdata: string }>`
  width: 100%;

  /* height: 600px; */
  /* min-height: 500px; */
  ////overflow:scroll;

  ${({ hasdata }) =>
    hasdata === 'true' && 'border: 1px solid var(--border-main, #ededed);'}

  table {
    /* height: 100%; */
    /* table-layout: fixed; */
    width: 100%;
    border: none;
    border-collapse: collapse;

    td {
      border: none;
      vertical-align: middle;
      padding: 8px;
      /* height: fit-content; */

      p {
        text-align: center;
        vertical-align: middle;
      }
    }

    tbody td {
      border-bottom: 1px solid #ededed;
    }
  }
`


export const LinkedInterpretations = (props: any) => {
  let { data, language = 'en' } = props || {}
  // const { recommendations } = useAppSelector((state) => state.data)
  let [filter, setFilter] = useState<any>({
    sort: '_id',
    perPage: MAX_PER_PAGE,
    search: '',
    // direction: 'asc',
    filter: {},
  })
  const hasdata = data?.length > 0 ? 'true' : 'false'

  console.log("LinkedInterpretations", IdInterpreationBody)
  return (
      <TableStyle hasdata={hasdata}>
        <Table
            Head={IdInterpretationHead}
            Body={(props: any) => <IdInterpreationBody {...props} language={language} />}
            EmptyItems={() => <EmptyTable name={'disease'}/>}
            NothingFound={NothingFound}
            apiSearchFileds={['name']}
            onFilter={(it: any, filter: any) => {
              if (filter._id) {
                return it._id == filter._id
              }
              return true
            }}
            onSearch={(it: any, reg: any) => {
              return reg.test(it.name)
            }}
            onChangeFilter={(v: any) => {
              setFilter(v)
            }}
            filter={filter}
            items={data}
        />
      </TableStyle>
  )
}

const IdRecommendationsTable = (props: any) => {
  let { data } = props || {}
  // const { recommendations } = useAppSelector((state) => state.data)
  let [filter, setFilter] = useState<any>({
    sort: '_id',
    perPage: MAX_PER_PAGE,
    search: '',
    // direction: 'asc',
    filter: {},
  })
  const hasdata = data?.length > 0 ? 'true' : 'false'

  return (
    <TableStyle hasdata={hasdata}>
      <Table
        Head={IdRecommendationsHead}
        Body={IdRecommendationsBody}
        EmptyItems={() => <EmptyTable name={'recommendation'}/>}
        NothingFound={NothingFound}
        apiSearchFileds={['name']}
        onFilter={(it: any, filter: any) => {
          if (filter._id) {
            return it._id == filter._id
          }
          return true
        }}
        onSearch={(it: any, reg: any) => {
          return reg.test(it.name)
        }}
        onChangeFilter={(v: any) => {
          setFilter(v)
        }}
        filter={filter}
        items={data}
      />
    </TableStyle>
  )
}

export default IdRecommendationsTable
